import styled from "styled-components";
import { theme } from "../theme/toyotaTheme";
import * as ButtonStyles from "./Button";

export const Button = styled.button`
    display: inline-block;
    align-self: stretch;
    padding: ${theme.space[2]}px;
    font-size: 1.6rem;
    line-height: 2.4rem;
    color: ${theme.colors.primaryBlack};
    white-space: nowrap;
    background-color: ${theme.colors.grey2};
    border: 0;

    ${ButtonStyles.EllipsisText} {
        display: inline-block;
        max-width: 60px;
    }
`;

export const IconBadge = styled.span`
    position: relative;
    margin-left: ${theme.space[2]}px;

    svg {
        color: ${theme.colors.primaryBlack};
    }

    span {
        position: absolute;
        top: -12px;
        right: -8px;
        width: 18px;
        height: 18px;
        font-size: 1.3rem;
        line-height: 1.8rem;
        text-align: center;
        color: ${theme.colors.primaryWhite};
        background-color: ${theme.colors.primaryRed};
        border-radius: 100%;
    }

    html[dir="rtl"] & {
        margin-left: 0;
        margin-right: ${theme.space[2]}px;
        span {
            left: -8px;
            right: auto;
        }
    }
`;

export const MobileBasket = styled.div`
    display: flex;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    flex: 1 1 auto;
    flex-direction: column;
    overflow-x: hidden;
    overflow-y: auto;
    margin-top: -1px;
    padding: 0 ${theme.space[3]}px ${theme.space[3]}px;
    background-color: ${theme.colors.primaryBlack};
    border-top: 1px solid ${theme.colors.grey2};
    z-index: ${theme.zIndex.overlay};
`;

export const BasketTitle = styled.h2`
    margin: 0;
    padding: 0;
    font-family: ${theme.fonts.regular};
    font-size: 2rem;
    line-height: 2.4rem;
    text-align: start;
    text-transform: none;
`;
